/*
  uat环境配置
*/
export default  { // http://wedof-itsm.beta.autoai.com
    ssoServiceUser: 'http://itsmops.uat.autoai.com/usercenter/sso/operator/www/v1/', // 用户登录
    baseURL:"http://itsmops.uat.autoai.com/itsm/v1/",      // 业务接口
    BASE_API: 'http://itsmops.uat.autoai.com/',       // 上传
    // roleUrl:"http://itsmauth.uat.autoai.com/",           // 权限
    roleUrl:"http://wedof-auth.uat.autoai.com/",// 新权限
    BASEURL:"//itsmops.uat.autoai.com/",         //CICD关联
    // ssoService: 'http://wedof-auth-api.uat.autoai.com/', // 用户权限管理
    AuthUrl:"http://wedof-authority.beta.autoai.com/authority/v1/",  //请求新权限系统
    timeout: 30000,
    withCredentials: true,
    filterUser:'https://wedof.autoai.com/',//搜索人员接口域名
    pageTitle: 'vue管理系统后台模版',
};
